<template>
  <v-app>
      <v-container
              class="text-center"
              fill-height
              style="height: calc(100vh - 58px);">
          <v-row align="center">
              <v-col>
                  <h1 class="display-2 primary--text">{{ $t('website_unreachable_title') }}</h1>

                  <p>{{ $t('website_unreachable_description') }}</p>

                  <v-btn color="primary"
                         @click="reload()"
                          outlined>
                      {{ $t('website_unreachable_retry_button') }}
                  </v-btn>
              </v-col>
          </v-row>
      </v-container>
  </v-app>
</template>

<script>

export default {
  name: 'App',
    methods: {
        reload() {
            location.reload();
        }
    }
}
</script>
